/* eslint-disable jsx-a11y/no-access-key */
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import Notification from '../Notification'
import logo from './assets/Component-3–1.svg'
import logoLight from './assets/Component-3–1-light.svg'
import logoDark from './assets/Component-3–1-dark.svg'
import burger from './assets/burger.svg'
import burgerDark from './assets/burgerDark.svg'
import tlIcon from './assets/tl-Icon.png'
import style from './style.module.sass'
import { useSelector } from 'react-redux'
import BatchProcessingProgressbar from '../../Analysis/BatchProcessing/BatchProcessingProgressbar'
import ArchiveProgressbar from '../../Archive/ArchiveProgressBar'
import DropdownUser from './DropdownUser'
import { isObjectEmpty } from '../../../utils'
import NotificationsIcon from '@material-ui/icons/Notifications'
import Spinner from '../../Spinner'
import TLServiceComponent from '../../../contexts/TLServiceComponent'
import { useActions } from '../../../utils/action-helper'
import { messagePageRefresh, messagesUserUnread } from '../../../actions'
import config from '../../../config'
import { useTranslation } from 'react-i18next'
import ThemeHandler from './ThemeHandler/ThemeHandler'
import { useTheme } from '@material-ui/styles'


function Header ({ setOpen, }) {
  const {t} = useTranslation()
  const {theme: {bgColors, colors}} = useTheme()
  const [openPersonalModalWin, setOpenPersonalModalWin] = useState(false)
  const [openNotify, setOpenNotify] = useState(false)
  const batchProcessingState = useSelector(state => state.batchData)
  const analyseProgressBar = useSelector(state => state.analyseData.analyseProgressBar)
  const messages = useSelector(state => state.userData.messages)
  const disableInfoMessages = useSelector(state => state.userData.user?.user_options?.disable_info_messages || false)
  const token = useSelector(state => state.userData.token)
  const userId = useSelector(state => state.userData.user.id)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

  const tlService = React.useContext(TLServiceComponent)
  const iaw = messages.getWarningsAndInfo()
  const [submitted, setSubmitted] = useState(false)

  const {
    actionMessagePageRefresh, actionMessagesUserUnread
  } = useActions({
    actionMessagePageRefresh: messagePageRefresh,
    actionMessagesUserUnread: messagesUserUnread(tlService),
  })
  let filter
  let burgerImage

  if (themeState === config.THEMES_MODES.CONTRAST_LIGHT) {
    filter = 'brightness(0) saturate(100%) invert(0%)'
    burgerImage = burger
  } else if (themeState === config.THEMES_MODES.CONTRAST_DARK) {
    filter = 'brightness(0) saturate(100%) invert(1)'
    burgerImage = burgerDark
  } else {
    filter = 'none'
    burgerImage = burger
  }

  let logoImg
  switch (themeState) {
    case config.THEMES_MODES.CONTRAST_LIGHT:
      logoImg = logoLight
      break
    case config.THEMES_MODES.CONTRAST_DARK:
      logoImg = logoDark
      break
    default:
      logoImg = logo
  }

  const handleMarkRead = async id => {
    setSubmitted(true)
    try {
      await tlService.setMessageRead(token, id)
      actionMessagesUserUnread(token, userId, !disableInfoMessages)
      actionMessagePageRefresh(true)
    } catch (e) {
      console.log(e)
    }
    setSubmitted(false)
  }

  return (
    <header className={`${style.header} d-flex justify-content-between`}>
      <div className={style.firstPart}>
        <button className={style.burgerNav} aria-label={t('accessibility_header_menu-burger')} aria-controls="main-navigation" aria-expanded="false" tabIndex={config.tabIndexes.navHamburger}  onClick={() => setOpen(true)} accessKey={config.accessKeys.navbarOpen}> <img src={burgerImage} className={style.burger} alt="" /> </button>
        <NavLink
          tabIndex={config.tabIndexes.TlLogo}
          to="/"
          exact={true}
          className={style.logo}
          aria-label={t('accessibility_header_home_logo')}>
          <img src={logoImg} alt=''/>
        </NavLink>
      </div>
      <div className={`${style.secondPart} "d-flex justify-content-between"`}>
        <div style={{
          marginRight: '20px',
          marginTop: '20px',
        }}>
          {(batchProcessingState.running || batchProcessingState.done || batchProcessingState.hasError) ?
            <BatchProcessingProgressbar/> : <></>
          }
          {!isObjectEmpty(analyseProgressBar) ? <ArchiveProgressbar/> : <></>}
        </div>
        <div className={`${style.utilityActions} utility-actions`}>
          <ThemeHandler />
          <div
            onClick={(event) => {
              event.preventDefault()
              setOpenPersonalModalWin(false)
              setOpenNotify(s => !s)
            }}
            tabIndex={config.tabIndexes.notificationButton}
            title={t('accessibility_header_notifications')}
            aria-label={t('Notifications')}
            style={{color: colors.colorIcons}}
            className="nav-link dropdown-toggle cursor-pointer"
            id="alertsDropdown">
            <NotificationsIcon/>
            {iaw && <span className="badge" style={{ backgroundColor: bgColors.bgDanger, color: colors.colorTextReverse}}>{iaw ? iaw[1] : 0}</span>}
          </div>
          <div
            onClick={(event) => {
              event.preventDefault()
              setOpenPersonalModalWin(s => !s)
              setOpenNotify(false)
            }}
            tabIndex={config.tabIndexes.avatarButton}
            aria-label={t('accessibility_header_user-avatar')}
            className={style.utilityLink}>
            <img
              src={tlIcon}
              className={style.avatar}
              style={{filter: filter}}
              alt=""
            />
          </div>
        </div>
      </div>
      {submitted && <Spinner/>}
      <DropdownUser setOpenPersonalModalWin={setOpenPersonalModalWin}
                    openPersonalModalWin={openPersonalModalWin}/>
      <Notification setOpen={setOpenNotify} open={openNotify} handleMarkRead={handleMarkRead}/>
    </header>
  )
}

export default Header
